import { DownloadButton } from "./styles";
import useDownloadConversation from "./use-download-to-cvs";
import { Tooltip } from "react-tooltip";

const DownloadConversationButton = () => {
	const { downloadCSV } = useDownloadConversation();
	return (
		<>
			<DownloadButton
				data-tooltip-id="download-tooltip"
				data-tooltip-content="Download as CSV"
				style={{ float: "right" }}
				icon="fas fa-download"
				onClick={downloadCSV}
			/>
			<Tooltip id="download-tooltip" place="top" />
		</>
	);
};

export default DownloadConversationButton;
